import { useMissionsTranslation } from '../../../../ui/hooks';
import { Box, Button } from '@mui/material';
import React from 'react';
export const ShiftParticipantTableActions = ({ onCheckinParticipant, onCheckoutParticipant, shiftAttendanceStatus, }) => {
    const { t } = useMissionsTranslation();
    if (!shiftAttendanceStatus) {
        return (React.createElement(Button, { variant: 'outlined', onClick: () => onCheckinParticipant() }, t('shifts.ongoingShifts.actionLabel.checkIn')));
    }
    if (shiftAttendanceStatus === 'checkedIn') {
        return React.createElement(Button, { onClick: () => onCheckoutParticipant() }, t('shifts.ongoingShifts.actionLabel.checkOut'));
    }
    return React.createElement(Box, { sx: { pr: 6 } }, "-");
};
